import { useContext } from 'react';
import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import useGlynt from '../useGlynt';
import { PaginatedPackagesResponse } from '../../../types/packager-types';
import { AppContext } from '../../../App';
import { IPackagesListParams } from '../../../api/packages';

export const useGetPackages = (
  params?: IPackagesListParams,
  options?: Pick<UseQueryOptions<PaginatedPackagesResponse>, 'refetchInterval'>
) => {
  const { dataPoolId } = useContext(AppContext);
  const glynt = useGlynt();

  return useQuery({
    queryKey: ['packages', dataPoolId, params?.limit, params?.offset],
    queryFn: async () => await (await glynt).packages.retrieve(params),
    refetchOnWindowFocus: false,
    ...options,

    // 1 hour
    gcTime: 1000 * 60 * 60,

    // 10 minutes
    staleTime: 1000 * 60 * 10
  });
};
